
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#826e4e"}},[_c('path',{attrs:{"d":"M16 16h8v8h-8z"}}),_c('path',{attrs:{"d":"M0 0v40h40V0H0zm32 16v8h-8v8H8V16h8V8h16v8z"}})])])
          )
        }
      }
    